exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-Map-___styles__map___2pgSP {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  right: 0; }\n\n.src-components-Map-___styles__popup___2Uadr {\n  max-width: 480px; }\n  .src-components-Map-___styles__popup___2Uadr h1 {\n    font-size: 18px;\n    margin: 0 0 4px; }\n  .src-components-Map-___styles__popup___2Uadr .src-components-Map-___styles__subjects___1bG2- {\n    margin-bottom: 8px; }\n", ""]);

// exports
exports.locals = {
	"map": "src-components-Map-___styles__map___2pgSP",
	"popup": "src-components-Map-___styles__popup___2Uadr",
	"subjects": "src-components-Map-___styles__subjects___1bG2-"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?modules&importLoaders=1&localIdentName=[path]___[name]__[local]___[hash:base64:5]!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./node_modules","./node_modules/grommet/node_modules"]}!./src/components/Map/styles.scss
// module id = 447
// module chunks = 0